<div class="bg-pattern"></div>

<mat-progress-bar mode="indeterminate"></mat-progress-bar>
